const buildSections = (c) => [
  { id: "context", label: "Context", value: c.context },
  { id: "the-challenge", label: "The Challenge", value: c.challenge },
  { id: "the-insight", label: "The Insight", value: c.insight },
  { id: "the-idea", label: "The Idea", value: c.solution },
  { id: "execution", label: "Execution", value: c.execution },
];

export const CaseBody = ({ campaign: c }) => {
  const rows = buildSections(c);

  return (
    <section className="hairline-b border-b">
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-24 grid grid-cols-12 gap-8 md:gap-12">
        <div className="col-span-12 md:col-span-3">
          <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
            The Story
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight leading-[0.95]">
            How it<br />came together.
          </h2>
        </div>

        <div className="col-span-12 md:col-span-8 md:col-start-5 space-y-10 md:space-y-12">
          {rows.map((row, i) => (
            <div
              key={row.id}
              data-testid={`case-section-${row.id}`}
              className="grid grid-cols-12 gap-4 md:gap-6 hairline-t border-t pt-6 md:pt-8 reveal"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="col-span-12 md:col-span-3 text-[10.5px] tracking-[0.22em] uppercase font-medium opacity-60">
                {String(i + 1).padStart(2, "0")} · {row.label}
              </div>
              <p className="col-span-12 md:col-span-9 text-base md:text-xl leading-relaxed text-[var(--ink)]">
                {row.value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
